import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { AppBar, FontIcon, IconButton } from 'material-ui'
import { NavigationMoreVert } from 'material-ui/svg-icons'

import Menu from './elements/Menu'
import Tasks from './Tasks/'
import Login from './Login/'

class App extends Component {
  render() {
    return [
      <Menu key="menu" />,
      <Switch key="rootRoute">
        <Route path="/tasks" component={Tasks} />
        <Route path="/login" component={Login} />
        {/* <Route path="/submit" component={Submit} /> */}
        <Route path="/" render={() => <Redirect to="/tasks" />} />
      </Switch>,
    ]
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js